import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subject, forkJoin } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-staff-information',
  templateUrl: './staff-information.component.html',
  styleUrls: ['./staff-information.component.scss']
})
export class StaffInformationComponent implements OnInit, OnDestroy {
  StaffInfo: any[] = [];
  fetchinData = true;
  private ngUnsubscribe = new Subject();

  constructor(private appService: AppService, private _changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.FetchStaffInfo();
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next(null);
    this.ngUnsubscribe.complete();
  }

  FetchStaffInfo() {
    this.fetchinData = true;
    forkJoin([
      this.appService.getTeaherStaff(),
    ]).pipe(takeUntil(this.ngUnsubscribe)).subscribe((response: any) => {
      const allData = response[0].data || [];
      this.StaffInfo = allData.filter((x: any) => {
        const arena = (x.JobArena || x.jobArena || '').toString().trim().toLowerCase();
        return arena === 'office staff';
      });
      this.fetchinData = false;
      this._changeDetectorRef.markForCheck();
    });
  }
}
